import React, { useEffect, useState } from 'react'
import './single.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import { useParams } from 'react-router-dom'
import { collection, doc, getDocs, onSnapshot, query, where } from 'firebase/firestore'
import { db } from '../../../firebase'
import avarterImage from '../../../assets/images/user.png'



const Single = () => {

  const {reviewId} = useParams()

  const [reviewData, setReviewData] = useState([])


  // useEffect(() => {
      
  //     const reviewQuery = async() => {
  
  //       const reviewRef = (collection(db, "reviews"));

  //       const q = query(reviewRef, where("reviewId", "==", reviewId));
  
  //       const querySnapshot = await getDocs(q);

  //       let list = []

  //       querySnapshot.forEach((doc) => {

  //         list.push({id: doc.id, ...doc.data(), timeStamp: doc.data().timeStamp.toDate()})

  //         console.log(list)
  
  //         setReviewData(list)
  //         // console.log(riderData)
  //       });

  
  //     }
      
  //     reviewQuery()   
  //   },[])


    
   const getReviewInfo = () => {
  
      onSnapshot(doc(db, "reviews", reviewId), (doc) => {
    
      console.log("Current data: ", doc.data());
    
      setReviewData({id: doc.id, ...doc.data()})
    
      
     });
    
    
  }
  
    useEffect(()=>{
  
      getReviewInfo()
      
  
    }, [])



  console.log('review data: ', reviewData)
  
  return (
    <div className='single'>
      <Sidebar/>
      <div className='singleContainer'>
        <Navbar/>
        <div className="top">
          <div className="left">
            <h2 className='title'>Review Photo</h2>
            <div className='item'>
                <img
                    src={reviewData.userImage ? reviewData.userImage : avarterImage}
                    alt="avatar"
                    style={{width:120, height:120}}
                    // className="itemimg"

                />
              
            </div>
          </div>


           <div className="left">
            {/* <div className="editbutton">Edit</div> */}
            <h2 className='title'>Review Info</h2>
            <div className='item'>
                <div className="details">
                  {/* <h3 className='itemTitle'>Review </h3> */}
                  <div className='detailItem'>
                    <span className='itemKey'>Review:</span>
                    <span className='itemValue'>{reviewData.firstname} {reviewData.surname}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Message:</span>
                    <span className='itemValue'>{reviewData.message}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Status:</span>
                    <span className='itemValue'>{reviewData.status}</span>
                  </div>
                  <div className='detailItem'>
                    <span className='itemKey'>Telephone:</span>
                    <span className='iitemValue'>{reviewData.telephone}</span>
                  </div>
                </div>
            </div>
          </div>
       
        </div>
        {/* <div className='bottom'>

          <h2 style={{fontSize:18, fontWeight:'bold', color:'#999', marginTop:20, marginBottom:50}}>Customers Review</h2>

          {

            reviewData.map(item => {

              return(
                
                <div style={{display:'flex', flexDirection:'row', gap:20}}>
                
              
                  <img

                    src={image}
                    alt="avatar"
                    style={{width:80, height:80, borderRadius:'50%'}}
                    // className="itemimg"

                  />

                <div style={{display:'flex', flexDirection:'column', marginLeft:20, gap:10}}>
                  <p style={{color:'#666', fontSize:16}}>{item.commentor}</p>
                  <p style={{color:'#ccc', fontSize:14}}>{item.today}</p>
                  <p style={{fontSize:16, color:'#999'}}>{item.review}</p>
                </div>

             </div>

              )
            })
            
          }

        </div> */}
      
      </div>
    </div>
  )
}

export default Single

